module.exports = __webpack_public_path__ + "img/tj.3dd9395f.svg";